import React, { useContext } from "react";

import {
  ButtonMenu,
  ContentFeedback,
  CustomText,
  Pagination,
  Table,
} from "../../components/index";
import Styles from "./styles";

import { masks } from "../../utils";
import { hooks } from "../../utils";
import { StorageContext } from "../../contexts/StorageContext";

import { api } from "../../services";

import { fonts, SVG } from "../../config";

import Visibility from "@material-ui/icons/Visibility";
import { Add, Check, Close, Edit, ExpandMore, Mail } from "@material-ui/icons";
import { customModal, errorModal } from "../../components/modals/utils";
import ModalRegistry from "./components/ModalRegistry";
import Filters from "./components/Filters";
import ModalView from "../myProperties/components/ModalView";
import ModalViewReservation from "../reservation/components/ModalView";
import alerts from "../../utils/alerts";
import {
  BsExclamation,
  BsExclamationTriangle,
  BsExclamationTriangleFill,
  BsPersonFillSlash,
} from "react-icons/bs";
import ModalAprove from "./components/ModalAprove";

const PAGE_SIZE = 8;

function RegistryReservation() {
  const { loading, call } = hooks.useRequest();

  const [page, setPage] = React.useState<number>(0);
  const [currentFilter, setFilter] = React.useState<any>({});
  const [reservation, setReservation] = React.useState<any>(null);
  const [placeList, setPlaceList] = React.useState<any>([]);
  const [pageAct, setPageAct] = React.useState<number>(0);
  const [isMounted, setMount] = React.useState<boolean>(false);
  const [activeReservation, setActiveReservation] = React.useState<any>(null);
  const { getData } = useContext<any>(StorageContext);
  const condominiumId = getData("company_type");

  const Mount = React.useCallback(() => {
    call(
      null,
      api.getReservation({
        page: 0,
        size: PAGE_SIZE,
        condominiumId: condominiumId,
        type: "NORMAL",
      }),
      async (response) => {
        if (response.ok) {
          setReservation(response?.data);
        }
      }
    );
    call(
      null,
      api.getPlaces({
        page: 0,
        size: 999999,
        condominiumId: condominiumId,
      }),
      async (response) => {
        if (response.ok) {
          const list = response?.data?.content?.map((item) => {
            return { label: item.name, value: item.id };
          });
          setPlaceList(list);
        }
      }
    );
  }, []);

  React.useEffect(() => {
    if (!isMounted) {
      Mount();
      setMount(true);
    }
  }, [Mount, isMounted]);

  const Submit = async (page?: number) => {
    let filters = {
      ...currentFilter,
      page: page ? page : 0,
      size: PAGE_SIZE,
      condominiumId: condominiumId,
      type: "NORMAL",
    };

    call(null, api.getReservation(filters), async (response) => {
      if (response.ok) {
        setReservation(response?.data);
        setPage(page ? page : 0);
      }
    });
  };

  const openModal = () => {
    customModal.setInfos(
      "Cadastrar Reserva",
      [],
      null,
      null,
      <ModalRegistry
        page={page}
        placeList={placeList}
        reload={(value) => Submit(value)}
      />,
      false,
      true,
      <SVG.File />
    );
  };

  const openEditModal = (item) => {
    customModal.setInfos(
      "Editar Reserva",
      [],
      null,
      null,
      <ModalRegistry
        page={page}
        placeList={placeList}
        reload={(value) => Submit(value)}
        oldData={item}
        edit
      />,
      false,
      true,
      <Edit />
    );
  };

  const openAproveModal = (item) => {
    customModal.setInfos(
      "Aprovar Reserva",
      [],
      null,
      null,
      <ModalAprove page={page} item={item} reload={(value) => Submit(value)} />,
      false,
      true,
      <Check />
    );
  };

  const openModalView = (item) => {
    call(null, api.getReservationData(item.id), async (response) => {
      if (response.ok) {
        customModal.setInfos(
          "Visualizar Dados do Imóvel",
          [],
          {
            onClick: () => {
              customModal.close();
            },
            label: "Voltar",
          },
          null,
          <ModalView item={response?.data} />,
          false,
          true,
          <Visibility />
        );
      }
    });
  };

  const openModalViewReservation = (item) => {
    customModal.setInfos(
      "Visualizar Ficha de Hóspedes",
      [],
      {
        onClick: () => {
          customModal.close();
        },
        label: "Voltar",
      },
      null,
      <ModalViewReservation
        item={item}
        onSubmit={(value) => console.log(value)}
      />,
      false,
      true,
      <SVG.File />
    );
  };

  const capitalizeText = (str) => {
    if (!str) {
      return str;
    }
    return str?.substring(0, 1)?.toUpperCase() + str?.substring(1);
  };

  const getStatus = (status: string) => {
    if (status === "FP") {
      return "Foto Pendente";
    } else if (status === "PA") {
      return "Aguardando Liberação";
    } else if (status === "AL") {
      return "Acesso Liberado";
    } else if (status === "AF") {
      return "Acesso Finalizado";
    } else if (status === "AR") {
      return "Acesso Recusado";
    } else if (status === "AC") {
      return "Acesso Cancelado";
    } else {
      return "-";
    }
  };

  const sendEmail = (item) => {
    customModal.setInfos(
      "Reenviar E-mail",
      [],
      null,
      null,
      <ModalAprove
        email
        page={page}
        item={item}
        reload={(value) => Submit(value)}
      />,
      false,
      false,
      <Mail />
    );
  };

  const deniedAccess = (id: string) => {
    call(null, api.patchDeniedAccess({ reservationId: id }), (response) => {
      if (response.ok) {
        Submit(page);
        customModal.setInfos(
          "Recusar Reserva",
          ["Reserva recusada com sucesso!"],
          {
            label: "Ok, Entendi",
            onClick: () => {
              customModal.close();
            },
          },
          null,
          null,
          false,
          true,
          <Close />
        );
      }
    });
  };

  const getButtons = (status: string, item: any): any[] => {
    if (status === "PA") {
      return [
        {
          label: "Editar Reserva",
          icon: Edit,
          onClick: () => {
            openEditModal(item);
          },
        },
        {
          label: "Aprovar Reserva",
          icon: Check,
          onClick: () => {
            openAproveModal(item);
          },
        },
        {
          label: "Recusar Reserva",
          icon: Close,
          onClick: () => {
            deniedAccess(item.id);
          },
        },
        {
          label: "Visualizar os Dados do Imóvel",
          icon: Visibility,
          onClick: () => {
            openModalView(item);
          },
        },
        {
          label: "Visualizar Ficha dos Hóspedes",
          icon: Visibility,
          onClick: () => {
            openModalViewReservation(item);
          },
        },
      ];
    } else if (status === "AL") {
      return [
        {
          label: "Editar Reserva",
          icon: Edit,
          onClick: () => {
            customModal.setInfos(
              "Aviso",
              [
                "Alterações na reserva devem ser realizadas com, no mínimo, 30 minutos de antecedência em relação ao horário do checkout.",
              ],
              {
                label: "Editar",
                onClick: () => {
                  customModal.close();
                  openEditModal(item);
                },
              },
              {
                label: "Voltar",
                onClick: () => {
                  customModal.close();
                },
              },
              null,
              null,
              null,
              <BsExclamationTriangleFill />
            );
          },
        },
        {
          label: "Visualizar os Dados do Imóvel",
          icon: Visibility,
          onClick: () => {
            openModalView(item);
          },
        },
        {
          label: "Visualizar Ficha dos Hóspedes",
          icon: Visibility,
          onClick: () => {
            openModalViewReservation(item);
          },
        },
        {
          label: "Reenviar E-mail",
          icon: Mail,
          onClick: () => {
            sendEmail(item);
          },
        },
        {
          label: "Revogar Acesso",
          icon: BsPersonFillSlash,
          onClick: () => {
            customModal.setInfos(
              "Revogar Acesso",
              [
                "Ao revogar o acesso deste imóvel, o usuário vinculado com o mesmo terá sua chave atual desativada, porém sua compra referente a este imóvel continuará ativa. Continuar e revogar acesso?",
              ],
              {
                onClick: () => {
                  revokeAccess(item.id);
                  customModal.close();
                },
                label: "Sim, Revogar",
              },
              {
                onClick: () => {
                  customModal.close();
                },
                label: "Voltar",
              },
              null,
              null,
              null,
              <BsPersonFillSlash />
            );
          },
        },
        
      ];
    } else if (status === "AF" || status == "FP") {
      return [
        {
          label: "Editar Reserva",
          icon: Edit,
          onClick: () => {
            openEditModal(item);
          },
        },
        {
          label: "Visualizar os Dados do Imóvel",
          icon: Visibility,
          onClick: () => {
            openModalView(item);
          },
        },
        {
          label: "Visualizar Ficha dos Hóspedes",
          icon: Visibility,
          onClick: () => {
            openModalViewReservation(item);
          },
        },
      ];
    } else if (status === "AR") {
      return [
        {
          label: "Visualizar os Dados do Imóvel",
          icon: Visibility,
          onClick: () => {
            openModalView(item);
          },
        },
      ];
    } else if (status === "AC") {
      return [
        {
          label: "Visualizar os Dados do Imóvel",
          icon: Visibility,
          onClick: () => {
            openModalView(item);
          },
        },
      ];
    } else {
      return [
        {
          label: "Visualizar os Dados do Imóvel",
          icon: Visibility,
          onClick: () => {
            openModalView(item);
          },
        },
      ];
    }
  };

  const revokeAccess = (id: string) => {
    call(null, api.patchReservationRevoke(id), (response) => {
      if (response.ok) {
        Mount();
      }
    });
  };

  function addOneDay(date: Date): Date {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + 1);
    return newDate;
  }

  async function updateReservationLists(filter?) {
      let newFilter = {
        page: 0,
        size: PAGE_SIZE,
        condominiumId: condominiumId,
        type: "NORMAL",
        ...(filter.place && { placeId: filter.place }),
        ...(filter.name && { guestName: filter.name }),
        ...(filter.email && { guestEmail: filter.email }),
        ...(filter.document && { guestDocument: filter.document }),
        ...(filter.solicitationDate && {
          minCreatedAtDate: masks.dateToSubmit(filter.solicitationDate),
          maxCreatedAtDate: masks.dateToSubmit(
            addOneDay(filter.solicitationDate)
          ),
        }),
        ...(filter.status && { status: filter.status }),
        ...(filter.endDate && {
          maxEndDate:
            masks.dateToSubmit(filter.endDate) +
            " " +
            (filter.checkOutTime || "23:59"),
        }),
        ...(filter.startDate && {
          minStartDate:
            masks.dateToSubmit(filter.startDate) +
            " " +
            (filter.checkInTime || "00:00"),
        }),
      };
  
      setFilter(newFilter);
  
      await call(null, api.getReservation(newFilter), async (response) => {
        if (response.ok) {
          setReservation(response?.data);
          setPage(0);
        }
      });
      await call(
        null,
        api.getReservation({
          ...newFilter,
          minEndDate: masks.dateToSubmit(new Date()) + " 00:00",
        }),
        async (response) => {
          if (response.ok) {
            setActiveReservation(response?.data);
            setPageAct(0);
          }
        }
      );
    }

  return (
    <>
      <Styles.ContainerSecondary>
        <Styles.RegitryContainer>
          <CustomText fontSize={2} textColor="#FFFFFF" fontFamily={fonts.bold}>
            Cadastrar Reserva
          </CustomText>
          <CustomText
            style={{ paddingRight: "8px" }}
            fontSize={1.75}
            textColor="#FFFFFF"
            fontFamily={fonts.regular}
          >
            Alguns dados básicos serão solicitados para o cadastro de uma nova
            reserva.
          </CustomText>
        </Styles.RegitryContainer>
        <Styles.RegitryButton
          startIcon={<Add />}
          fullWidth={false}
          onClick={openModal}
          disabled={loading}
          loading={loading}
        >
          Cadastrar
        </Styles.RegitryButton>
      </Styles.ContainerSecondary>
      <Styles.ContainerFilter>
        <CustomText
          style={{ paddingBottom: "8px" }}
          fontSize={2}
          textColor="#4D585A"
          fontFamily={fonts.bold}
        >
          Filtrar Reserva
        </CustomText>
        <Filters
          onSubmit={(data) => {
            //TODO, check Status and add correct filter
            updateReservationLists(data);
          }}
          loading={false}
          placeList={[
            { label: "Todos", value: "" },
            { label: "Foto Pendente", value: "FP" },
            { label: "Acesso Liberado", value: "AL" },
            { label: "Acesso Finalizado", value: "AF" },
            { label: "Acesso Recusado", value: "AR" },
            { label: "Acesso Cancelado", value: "AC" },
          ]}
        />
      </Styles.ContainerFilter>
      <Styles.Container>
        <CustomText
          style={{ padding: "16px 20px" }}
          fontSize={2}
          textColor="#4D585A"
          fontFamily={fonts.bold}
        >
          Histórico de Reservas Cadastradas Manualmente
        </CustomText>
        <ContentFeedback data={reservation?.content} loading={loading}>
          <Table
            lastAlign={false}
            data={reservation?.content}
            renderItemColumns={(item) => [
              item?.place?.name,
              capitalizeText(item?.primaryGuest?.name),
              item?.primaryGuest?.document
                ? masks.CPF(item?.primaryGuest?.document)
                : item?.primaryGuest?.passport,
              item?.primaryGuest?.email,
              masks.formatDate(item?.startDate) +
                " " +
                masks.extractHour(item?.startDate),
              masks.formatDate(item?.endDate) +
                " " +
                masks.extractHour(item?.endDate),
              masks?.formatDate(item?.createdAt),
              <b>{getStatus(item?.status)}</b>,
              <ButtonMenu
                endIcon={<ExpandMore />}
                buttons={getButtons(item.status, item)}
              >
                Opções
              </ButtonMenu>,
            ]}
            headers={{
              table: [
                "IMOVEL",
                "NOME USUÁRIO",
                "DOCUMENTO",
                "E-MAIL",
                "CHECK-IN",
                "CHECK-OUT",
                "DATA DO CADASTRO",
                "STATUS",
                "AÇÃO",
              ],
              keys: [],
            }}
          />
          <Pagination
            style={{ padding: "16px 20px", paddingTop: 0 }}
            page={page + 1}
            totalPages={reservation?.totalPages}
            setPage={(number) => {
              Submit(number - 1);
            }}
          />
        </ContentFeedback>
      </Styles.Container>
    </>
  );
}

export default RegistryReservation;
